<template>
  <div class="packDetails">
    <Addlog :Type='logType' ref='addlog' v-if='$store.state.Stages.visible'></Addlog>
    <div class="tp">
      <div class="cardli">
        <div class="h2">
          基本信息
        </div>
        <div style="padding:20px;">
          <a-row style="margin-bottom:20px;">
            <a-col :span='10'>
              <label>债务人：</label>
              <span>{{info.realname}}</span>
            </a-col>
            <a-col :span='10'>
              <label>债务人证件号码：</label>
              <span>{{info.chinaid}}</span>
            </a-col>
            <a-col :span='4'>
              <label>联系方式：</label>
              <span>{{info.phone}}</span>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span='10'>
              <label>户籍所在地：</label>
              <span>{{info.province + info.city + info.area + info.addr}}</span>
            </a-col>
            <a-col :span='10'>
              <label>经常居住地：</label>
              <span>{{info.dwell_province?info.dwell_province + info.dwell_city + info.dwell_area + info.dwell_addr : info.province + info.city + info.area + info.addr}}</span>
            </a-col>
          </a-row>
        </div>
      </div>
      <div class="cardli">
        <div class="cktbox">
          <div class="chbox">
            <a href="javascript:void(0);" v-for='(i,index) in info.cause' :key='i.id' :class='{"cur":index==curIndex}' @click='ck(i,index)'>案件{{i.sort}}</a>
          </div>
          <router-link :to='{"name":"paybackDetails",params:{id:$route.params.id}}' target='_blank' v-if="$common.AUTH('loan:add')">
            <a-button type="primary" icon='plus'>添加分期 </a-button>
          </router-link>
        </div>
        <div class="h2">案件信息</div>
        <a-row class="rows nrows">
          <a-col :span='3' style="display:flex;">
            <label>录入时间：</label>
            <div class="span">{{info.cause[curIndex].create_time | yearFormat}}</div>
          </a-col>
          <a-col :span='5' style="display:flex;">
            <label>原告：</label>
            <div class="span">
              <Normap :tit='info.cause[curIndex].accuser?info.cause[curIndex].accuser.title:""'></Normap>
            </div>
          </a-col>
          <a-col :span='5' style="display:flex;">
            <label>案号：</label>
            <div class="span">
              <Normap :tit='info.cause[curIndex].no'></Normap>
            </div>
          </a-col>
          <a-col :span='2' style="display:flex;">
            <label>案件：</label>
            <div class="span">案件{{info.cause[curIndex].sort}}</div>
          </a-col>
          <a-col :span='4' style="display:flex;">
            <label>案件进度：</label>
            <div class="span" v-if='info.cause[curIndex].step.length>0'>{{info.cause[curIndex].step[0].title}}</div>
          </a-col>
          <a-col :span='5' style="display:flex;">
            <label>管辖法院：</label>
            <div class="span">
              <Normap :tit='info.cause[curIndex].court'></Normap>
            </div>
          </a-col>
        </a-row>
        <!-- <a-row class="rows">
      

      </a-row> -->
        <div class="h2" style="margin-top:20px;">
          分期信息
          <a-button type="primary" icon='plus' v-if='ingLoan.status==4 && loanIndex==loan.length-1 && edit==0' @click='addNew'>添加分期信息</a-button>
        </div>
        <div class="cktbox">
          <div class="chbox">
            <a href="javascript:void(0);" v-for='(i,index) in loan' :key='i.id' :class="{'cur':loanIndex==index}" @click='seeLoan(index)'>分期{{index+1}}</a>
          </div>
          <a-button type="primary" ghost v-if='ingLoan.status!=4 && loanIndex==loan.length-1 && $common.AUTH("credit:loan:edit")' @click='putEdit(nowLoan)'>修改</a-button>
        </div>
        <div class="colsown" v-if='edit==0'>
          <div class="tl">
            <div class="sapn" v-for='i in rPropo(nowLoan.fee)'>{{i.type_title}}：{{i.fee/100}}元</div>
          </div>
          <div class="btl">
            <div class="sapn">总合计金额： <span>{{nowLoan.total/100}}元</span></div>
            <div class="sapn">分期期数： <span>共{{nowLoan.quantity}}期</span></div>
          </div>
          <div class="csays">
            <label>备注：</label>
            <div class="says" v-html='nowLoan.comment'>

            </div>
          </div>
          <div class="h3">分期详情</div>
          <div class="table">
            <table>
              <thead>
                <td width='232'>每期编号</td>
                <td width='142'>当前期数</td>
                <td width='126'>还款金额</td>
                <td width='150'>还款日期</td>
                <td width='120'>还款构成</td>
                <td width='122'>还款状态</td>
                <td width='118'>已还金额</td>
                <td width='138'>还款进度</td>
                <td width='74'>操作</td>
              </thead>
              <tbody>
                <tr v-for='(i,index) in nowLoan.period' :key='index'>
                  <td>
                    <Normap :tit='i.no'></Normap>
                  </td>
                  <td>第{{index+1}}期</td>
                  <td>{{i.fee/100 | toNum}}</td>
                  <td>{{i.time}}</td>
                  <td>
                    <a-popover>
                      <template slot="content">
                        <div class="contbox">
                          <p v-for='(k,inde) in i.fee_list'>{{k.type_title}}:{{k.fee | showYuan}}</p>
                        </div>
                      </template>
                      <span> {{Allfree(i.fee_list)}}</span>
                    </a-popover>
                  </td>
                  <td>
                    <span class="status ing" v-if='i.status==1'>待还款</span>
                    <span class="status succ" v-if='i.status==2'>已还款</span>
                    <span class="status err" v-if='i.status==3'>已逾期</span>
                    <span class="status oky" v-if='i.status==4'>已申请执行</span>
                  </td>
                  <td>
                    {{i.payee/100 | toNum}}
                  </td>
                  <td>
                    {{(i.payee/i.fee*100).toFixed(2)}}%
                  </td>
                  <td>
                    <!-- <a-popconfirm title="确认提交此条数据吗?" ok-text="确定" cancel-text="取消" @confirm="cement(i.id)" v-if='i.status==3 && $common.AUTH("credit:loan:do")'>
                      <span>申请执行</span>
                    </a-popconfirm> -->
                    <div>
                      <router-link :to='{"name":"lydetails",params:{"id":$route.params.id},query:{e:info.cause[curIndex].sort}}' v-if='i.status==3' target='_blank'>申请执行</router-link>
                      <span v-else>-</span>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="forms" v-else>
          <a-form-model ref="forms" :model="form" :rules="rules" :label-col="{span: 4}" :wrapper-col="{span: 20}" class="rform" :class='{"editbox":$route.params.id}'>
            <a-row class="clearbox">
              <a-col :span='4'>
                <a-form-model-item label="期数" :label-col="{span: 24}" prop='quantity' :rules="{ required: true, message: '请输入期数',trigger: 'blur'}" class="bjlabel">
                  <a-input-number v-model="form.quantity" :min="1" style="width:180px;" placeholder="请输入期数" />
                </a-form-model-item>
              </a-col>
              <a-col :span='4'>
                <a-form-model-item label="本金" :label-col="{span: 24}" prop='capital' :rules="{ required: true, message: '请输入本金',trigger: 'blur'}" class="bjlabel">
                  <a-input-number v-model="form.capital" :min="1" style="width:180px;" placeholder="请输入本金" :class='{"yellow":capitalAudit}' :disabled="capitalAudit" />
                </a-form-model-item>
              </a-col>
              <a-col :span='4'>
                <a-form-model-item label="利息" :label-col="{span: 24}" prop='used_fee' :rules="{ required: false, message: '请输入利息',trigger: 'blur'}">
                  <a-input-number v-model="form.used_fee" :min="1" style="width:180px;" placeholder="请输入利息" :class='{"yellow":usedAudit}' :disabled="usedAudit" />
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-form-model-item label="诉讼相关费用" :label-col="{span: 3}" class="lflabel" prop='loan_fee_list' :rules="{ required: false, message: '请选择诉讼相关费用',trigger: 'blur'}">
              <a-button icon="plus" @click='plusAdd(1)'>诉讼费</a-button>
              <a-button icon="plus" @click='plusAdd(2)'>公告费</a-button>
              <a-button icon="plus" @click='plusAdd(3)'>保全费</a-button>
              <a-button icon="plus" @click='plusAdd(4)'>律师费</a-button>
              <a-button icon="plus" @click='plusAdd(5)'>差旅费</a-button>
              <!-- <a-button icon="plus" class="mr20" @click='plusAdd(6)'>退费</a-button> -->
              <a-button icon="plus" @click='plusAdd(10)'>上诉费</a-button>
              <a-button icon="plus" @click='plusAdd(7)'>其他</a-button>
            </a-form-model-item>
            <div class="fourlist">
              <div class="dul" v-if='form.loan_fee_list.length>0'>
                <div class="ul">
                  <div v-for='(i,index) in form.loan_fee_list' :key="index" class="dli">
                    <a-form-model-item :label="i.type | CreditName" :label-col="{span: 8}" :wrapper-col="{span: 16}" :prop="'loan_fee_list.' + index + '.fee'" :rules="[{ required: true, message: '请输入', trigger: ['change', 'blur'] },{
                        validator: Validator.priceVal, trigger: ['change', 'blur'] }]">
                      <a-input-number v-model="i.fee" :min="1" style="width:140px;" placeholder="请输入" :class='{"yellow":i.audit}' :disabled="i.audit" />
                    </a-form-model-item>
                    <div class="btns" @click='del(index)' v-if='!i.audit'>
                      <a-icon type="minus-circle" />
                    </div>
                  </div>
                </div>
              </div>
              <div class="bot">
                <label>还款总金额：</label>
                <span> {{Allpirce | toNum}}</span>
              </div>
              <div class="txtbox">
                <label>备注</label>
                <div class="textarea">
                  <textarea v-model='form.comment' maxlength="500"></textarea>
                  <div class="bot">{{form.comment.length}}/500</div>
                </div>
              </div>
              <div class="cardli" v-if='edit>0'>
                <div class="h2">
                  分期详情 <a-button type='primary' @click='postStages(2)' ghost icon='plus' style="float:right;margin-top:12px;">添加分期详情</a-button>
                </div>

                <div class="ltable" v-if='Stages.list.length>0'>
                  <div class="table">
                    <table>
                      <thead>
                        <td width='10%'>当前期数</td>
                        <td width='20%'>还款日期</td>
                        <td width='20%'>还款金额</td>
                        <td width='40%'>还款构成</td>
                        <td width='10%'>操作</td>
                      </thead>
                      <tbody>
                        <tr v-for='(i,index) in Stages.list' :key='index'>
                          <td>第{{index+1}}期</td>
                          <td>{{i.time}}</td>
                          <td>{{i.fee}}</td>
                          <td>
                            <span v-for='(j,ind) in i.list' v-if='j.fee>0'>
                              {{j.type | CreditName}} :{{j.fee}}
                            </span>
                          </td>
                          <td>
                            <a-button type="link" @click='postStages(1,i,index)' style="padding:0;">修改</a-button>
                            <span class="line"></span>
                            <a-popconfirm title="确认删除此条数据吗?" ok-text="确定" cancel-text="取消" @confirm='postDel(index)'>
                              <a-button type="link" style="padding:0;">
                                <font color='#f00'>删除</font>
                              </a-button>
                            </a-popconfirm>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </a-form-model>
        </div>
      </div>
    </div>
    <!-- <div class="bots" v-if='edit==0 && nowLoan.id && $common.AUTH("audit:loan")'>
      <div class="h2" style="border:0 none;padding:0;">审核记录</div>
      <His :type='1' :loan_id='nowLoan.id'></His>
    </div> -->
    <CauseStepLog :id='loanId' v-if='edit==0 && loanId && $common.AUTH("loan:actionLog")' :type='true'></CauseStepLog>
    <div class="elbtns" v-if='edit>0'>
      <a-popconfirm title="确认提交此条数据吗?" ok-text="确定" cancel-text="取消" @confirm="confirm">
        <a href='javascript:void(0);' class="oky">
          提交
        </a>
      </a-popconfirm>
      <a href='javascript:void(0);' @click='reset' class="cancel">取消</a>
    </div>
  </div>
</template>
<script>
import Validator from "@/assets/js/yz.js"
import Proposition from './step.json'
import His from '@/components/his'
import CauseStepLog from '@/components/causeStepLog'
import Addlog from "./addlog"
import stepCredit from './../ly/stepCredit'
import { loanAdd, loanEdit, loanDetails, loancement } from '@/server/loan'
import { mapGetters } from 'vuex'
const formKey = {
  step: 0,
  name: "",
  cause_id: null,
  loan_fee_list: [],
  quantity: 1,
  capital: null,
  used_fee: null,
  comment: '',
  period_list: []
}
export default {
  data() {
    return {
      Validator,
      loanId: null,
      causeId: 0,
      curIndex: 0,//案件索引
      loanIndex: 0, //分期索引
      capitalAudit: false,
      usedAudit: false,
      rules: {},
      info: {
        cause: [
          {
            step: []
          }
        ],
      },
      loan: [
        {
          fee: []
        }
      ],
      edit: 0,    //0查看 1修改 2新增
      logType: 2,
      form: JSON.parse(JSON.stringify(formKey))
    }
  },
  components: { His, Addlog, CauseStepLog },
  computed: {
    ...mapGetters([
      'Stages',
    ]),
    nowLoan() {   //当前分期
      return this.loan[this.loanIndex]
    },
    ingLoan() {      //最新的分期 用来做按钮判断
      return this.loan[this.loan.length - 1]
    },
    Allpirce() {
      let newArr = this.form.loan_fee_list.map(ele => {
        return ele.fee ? ele.fee : 0
      })
      newArr.push(this.form.capital)
      newArr.push(this.form.used_fee)
      return newArr.reduce((a, b) => {
        return a + b
      })
    },
  },
  created() {
    this.init()
  },
  filters: {
    CreditName(key) {
      return stepCredit[key * 1]
    },
  },
  methods: {
    ck(i, index) {
      if (this.curIndex == index || this.edit == 1) {
        return false;
      }
      this.causeId = null
      this.loanId = null
      this.curIndex = index;
      this.loanIndex = i.loan.length - 1;
      this.loan = i.loan
      if (this.edit == 0) {
        setTimeout(e => {
          this.loanId = i.loan.length > 0 ? i.loan[0].id : null
          this.causeId = i.id
        }, 200)
      }
    },
    addNew() {
      const nowCause = this.info.cause[this.curIndex]
      this.$store.dispatch('Stages/setInfokey', { key: "list", value: [] })
      const step = nowCause.step.length == 0 ? 0 : nowCause.step[nowCause.step.length - 1].step
      let form = {
        step: step,
        name: nowCause.debtor_id,
        cause_id: nowCause.id,
        loan_fee_list: [],
        quantity: 1,
        comment: '',
        period_list: [],
        capital: null,
        used_fee: null,
      }
      this.form = form;
      this.loan.push({ fee: [], period: [], total: 0, quantity: 1 })
      this.loanIndex = this.loanIndex + 1
      this.edit = 2;
    },
    cement(id) {
      loancement({ period_id: id }).then(e => {
        this.$message.success({ content: '执行成功', key: 'updatable' });
        setTimeout(e => {
          window.history.go(0)
        }, 1000)
      })
    },
    Allfree(Arr) {
      let i = 0;
      let newNum = Arr.map(e => {
        i += e.fee * 1 / 100
      })
      return i.toFixed(2)
    },
    init() {
      loanDetails({ debtor_id: this.$route.params.id }).then(e => {
        this.info = e.info
        this.loan = e.info.cause[0].loan
        this.loanIndex = e.info.cause[0].loan.length - 1
        this.causeId = e.info.cause[0].id
        this.loanId = e.info.cause[0].loan.length > 0 ? e.info.cause[0].loan[0].id : null
        this.edit = 0
      })
    },
    rPropo(Arr) {
      let newArr = []
      Proposition.map(ele => {
        let s = Arr.find(s => { return s.type == ele.type })
        if (ele.type != 6) {
          newArr.push({
            type_title: ele.tit,
            type: ele.type,
            fee: s ? s.fee : 0
          })
        }
      })
      return newArr
    },
    putEdit(info) {   //修改
      const nowCause = this.info.cause[this.curIndex]
      let nlist = info.period.map(ele => {
        return {
          "audit": ele.audit == null ? false : true,
          "fee": ele.fee / 100,
          "id": ele.id,
          "time": ele.time,
          "list": ele.fee_list.map(s => {
            return {
              audit: s.audit == null ? false : true,
              id: s.id,
              fee: s.fee / 100,
              type: s.type,
            }
          })
        }
      })
      this.$store.dispatch('Stages/setInfokey', { key: "list", value: nlist })
      let loan_fee_list = info.fee.map(ele => {
        return {
          audit: ele.audit == null ? false : true,
          id: ele.id || 0,
          type: ele.type,
          fee: ele.fee / 100
        }
      }).filter(s => {
        return (s.type != 8 && s.type != 9)
      })
      const step = nowCause.step.length == 0 ? 0 : nowCause.step[nowCause.step.length - 1].step
      let form = {
        step: step,
        name: info.debtor_id,
        cause_id: info.id,
        loan_fee_list: loan_fee_list,
        quantity: info.quantity,
        comment: info.comment || '',
        period_list: this.$store.state.Stages.list
      }
      info.fee.map(ele => {
        if (ele.type == 8) {
          form.capital = ele.fee / 100
          form.capitalId = ele.id
          this.capitalAudit = ele.audit == null ? false : true
        }
        if (ele.type == 9) {
          form.used_fee = ele.fee / 100
          form.used_feeId = ele.id
          this.usedAudit = ele.audit == null ? false : true
        }
      })
      this.form = form;
      this.edit = 1;
    },
    async postStages(type, item, index) {   //添加分期 
      this.logType = type;
      if (type == 1) {
        await this.$store.dispatch('Stages/setInfokey', { key: 'curIndex', value: index })
        await this.$store.dispatch('Stages/setInfokey', { key: 'cur', value: item })
      }
      await this.$store.dispatch('Stages/setInfokey', { key: 'visible', value: true })
    },
    del(index) {
      this.form.loan_fee_list.splice(index, 1)
    },
    plusAdd(type) {
      this.form.loan_fee_list.push({
        type: type,
        fee: null,
        id: 0
      })
    },
    postDel(index) {   //删除表单
      this.$store.dispatch('Stages/reMove', index)
    },
    seeLoan(index) {
      if (this.loanIndex == index) return false;
      if (this.edit == 2) {
        this.loan.pop()
        this.$store.dispatch('Stages/setInfokey', { key: "list", value: [] })
      }
      this.edit = 3;
      this.form = JSON.parse(JSON.stringify(formKey))
      this.loanIndex = index
      setTimeout(e => {
        this.edit = 0;
      }, 100)
    },
    confirm() {
      this.$refs.forms.validate(valid => {
        if (valid) {
          let form = JSON.parse(JSON.stringify(this.form));
          form.period_list = JSON.parse(JSON.stringify(this.$store.state.Stages.list))

          if (form.period_list.length == 0) {
            this.$message.error({ content: '请添加分期', key: 'updatable' });
            return false;
          }
          form.period_list.map(ele => {
            ele.fee = ele.fee * 100
            ele.list.map(element => {
              element.fee = element.fee * 100
            })
          })
          if (form.period_list.length != form.quantity * 1) {
            this.$message.error("录入的期数与添加分期的数量需要一致")
            return false;
          }
          if (this.edit == 1) {      //修改
            let newform = form.loan_fee_list.filter(ele => {
              return (ele.type != 8 && ele.type != 9)
            })
            newform = newform.concat([{
              fee: form.capital,
              id: form.capitalId,
              type: 8
            }, {
              fee: form.used_fee,
              id: form.used_feeId || 0,
              type: 9
            }]).filter(ele => {
              return ele.fee > 0
            })
            newform.map(ele => {
              ele.fee = ele.fee * 100
            })
            form.loan_fee_list = newform
            delete form.capital
            delete form.used_fee
            delete form.capitalId
            delete form.used_feeId
            form.id = this.info.cause[this.curIndex].loan[this.loanIndex].id
            loanEdit(form).then(e => {
              this.$message.success({ content: '已提交审核', key: 'updatable' });
              setTimeout(e => {
                window.history.go(0)
              }, 1000)
            })
          } else {
            form.loan_fee_list = form.loan_fee_list.concat([{
              fee: form.capital,
              id: 0,
              type: 8
            }, {
              fee: form.used_fee,
              id: 0,
              type: 9
            }]).filter(ele => {
              return ele.fee > 0
            })
            delete form.capital
            delete form.used_fee
            form.loan_fee_list.map(ele => {
              ele.fee = ele.fee * 100
            })
            loanAdd(form).then(e => {
              this.$message.success({ content: '新增成功', key: 'updatable' });
              setTimeout(e => {
                window.history.go(0)
              }, 1000)
            })
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    reset() {
      if (this.edit == 2) {
        this.loan.pop()
        this.$store.dispatch('Stages/setInfokey', { key: "list", value: [] })
        this.loanIndex = this.loanIndex - 1
        this.edit = 0
      } else {
        this.edit = 0
      }
    }
  }
}
</script>
<style lang="less">
.packDetails {
  .lflabel {
    margin-bottom: 10px;
    .ant-form-item-label {
      text-align: left;
      width: 100px;
    }
    .ant-btn {
      padding: 0 6px;
      width: 84px;
      height: 28px;
      margin-right: 10px;
      color: #a2a3a5;
      font-size: 14px;
      span {
        margin-left: 4px;
      }
    }
    .ant-btn:hover,
    .ant-btn:focus {
      color: #1e8bfe;
      background-color: #fff;
      border-color: #1e8bfe;
    }
  }
  .rform {
    .ul {
      .ant-form-item-label {
        width: 60px;
      }
    }
  }
}
</style>
<style lang="less" scoped>
.packDetails {
  .cardli {
    background: #fff;
    margin-bottom: 10px;
  }
  .nrows {
    label {
      white-space: nowrap;
    }
    .span {
      max-width: 80%;
    }
  }
  .cktbox {
    display: flex;
    justify-content: space-between;
    height: 55px;
    margin: 0 20px;
    border-bottom: 1px solid #efefef;
    align-items: center;
    .chbox {
      display: flex;
      a {
        font-size: 14px;
        color: #0e2949;
        margin-right: 40px;
      }
      .cur,
      a:hover {
        color: #1d8bfe;
      }
    }
  }
  .h2 {
    line-height: 60px;
    font-size: 16px;
    font-weight: bold;
    color: #0e2949;
    padding: 0 20px;
    border-bottom: 1px solid #efefef;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .rows {
    margin: 20px 20px 0 20px;
    font-size: 14px;
    color: #0e2949;
    line-height: 20px;
    span {
      color: #66707c;
    }
  }
  .colsown {
    padding: 40px 20px 20px;

    .tl {
      display: flex;
      font-size: 14px;
      width: 1020px;
      flex-wrap: wrap;
      color: #0e2949;
      line-height: 20px;

      .sapn {
        width: 204px;
        margin-bottom: 10px;
      }
    }
    .btl {
      padding-top: 20px;
      display: flex;
      font-size: 14px;
      color: #0e2949;
      line-height: 20px;
      margin-bottom: 10px;
      .sapn {
        width: 204px;
        span {
          color: #0e2949;
          font-weight: bold;
        }
      }
    }
    .csays {
      display: flex;
      .says {
        width: 552px;
        font-size: 14px;
        color: #66707c;
        line-height: 20px;
      }
    }
  }
  .h3 {
    line-height: 60px;
    font-size: 14px;
    color: #0e2949;
    font-weight: bold;
  }
  .bots {
    margin-top: 10px;
    padding: 0 20px 20px;
    background: #fff;
    margin-bottom: 10px;
  }
  .forms {
    padding: 20px;
    .chbox {
      margin-bottom: 14px;
      border-bottom: 1px solid #efefef;
      line-height: 50px;
      a {
        color: #333;
        font-size: 14px;
        font-weight: 500;
        margin-right: 20px;
        transition-duration: 500ms;
      }
      a:hover,
      .cur {
        color: #1d8bfe;
      }
    }
    .clearbox {
      /deep/ .ant-form-item {
        margin-bottom: 10px;
      }
    }
  }
  .fourlist {
    margin-bottom: 20px;
    .bot {
      font-size: 14px;
      color: #0e2949;
      line-height: 20px;
    }
    .txtbox {
      margin-top: 20px;
      label {
        font-size: 14px;
        color: #0e2949;
      }
      .textarea {
        width: 572px;
        height: 132px;
        border-radius: 4px;
        border: 1px solid #dbdcde;
        padding: 10px;
        margin-top: 10px;
        textarea {
          width: 100%;
          height: 84px;
          border: 0 none;
        }
        .bot {
          text-align: right;
          font-size: 14px;
          color: rgba(162, 163, 165, 0.5);
          line-height: 20px;
        }
      }
    }
  }
  .ltable {
    padding: 20px;
  }
}
.elbtns {
  padding-top: 20px;
  a {
    display: inline-block;
    width: 80px;
    line-height: 36px;
    background: #1d8bfe;
    border-radius: 4px;
    text-align: center;
    margin-right: 20px;
    color: #fff;
  }
  .cancel {
    background: #b2c9e1;
  }
}
.dul {
  padding-top: 20px;
  box-sizing: border-box;
  background: #f3f6fb;
  border-radius: 4px;
  margin-bottom: 10px;
  padding-bottom: 10px;
  .ul {
    overflow: hidden;
    display: flex;
    flex-wrap: wrap;
  }
  .dli {
    padding-left: 30px;
    width: 25%;
    display: flex;
    margin-bottom: 10px;
    align-items: center;
    height: 60px;
    // overflow: hidden;
    .ant-form-item {
      margin: 0;
    }
    .btns {
      margin-left: 20px;
      color: #f00;
      cursor: pointer;
    }
  }
}
.mr20 {
  margin-right: 20px;
}
</style>